import * as routes from 'api/routes';

export type Params = { ttlInSecs?: number };
export type Result = { token: string; userId: string };

export const ROUTE = routes.KYC_GENERATE_ACCESS_TOKEN;
